var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard002(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 799.03 618.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6543fa;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #c1bbea;\n      }\n\n      .cls-4 {\n        fill: #f0eeff;\n      }\n\n      .cls-5 {\n        fill: #2d2165;\n      }\n\n      .cls-6 {\n        fill: #fcfdfd;\n      }\n\n      .cls-7 {\n        fill: #94d8f4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_782-3318",
    "data-name": "Path 782-3318",
    className: "cls-5",
    d: "M130.66,616.54c0,.87.48,1.57,1.07,1.57h535.1c.6,0,1.07-.7,1.07-1.57s-.48-1.57-1.07-1.57H131.73c-.6,0-1.07.7-1.07,1.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    className: "cls-3",
    x: 305.16,
    y: 611.35,
    width: 19.1,
    height: 3.37
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    className: "cls-3",
    x: 474.3,
    y: 611.92,
    width: 19.1,
    height: 3.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783-3319",
    "data-name": "Path 783-3319",
    className: "cls-4",
    d: "M426.67,461.33c-2.48,15-16.65,25.15-31.65,22.67-11.63-1.92-20.75-11.04-22.67-22.67h-69.49v150.59h193.3v-150.59h-69.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784-3320",
    "data-name": "Path 784-3320",
    className: "cls-5",
    d: "M788.26,465.26H10.78c-5.95,0-10.77-4.83-10.78-10.78V10.78C0,4.83,4.83,0,10.78,0h777.48c5.95,0,10.77,4.83,10.78,10.78v443.71c0,5.95-4.83,10.77-10.78,10.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    className: "cls-6",
    x: 19.55,
    y: 17.98,
    width: 760.82,
    height: 429.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_774",
    "data-name": "Rectangle 774",
    className: "cls-4",
    x: 548.35,
    y: 98.56,
    width: 149.17,
    height: 113.96,
    rx: 8,
    ry: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    className: "cls-2",
    x: 555.77,
    y: 104.22,
    width: 134.35,
    height: 102.64
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3446-3321",
    "data-name": "Path 3446-3321",
    className: "cls-5",
    d: "M625.3,180.36h.05c19.76-1.03,34.93-17.89,33.9-37.64-.94-18-15.12-32.5-33.1-33.85-.23-.02-.45.06-.62.21-.17.15-.26.37-.26.59l-.78,69.86c0,.45.36.82.81.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3447-3322",
    "data-name": "Path 3447-3322",
    className: "cls-7",
    d: "M597.21,120.41c.28,0,.54.12.74.32l24.05,24.6c.2.2.3.47.3.75l-.38,33.43c0,.29-.13.57-.34.76-.22.2-.5.3-.79.28-19.86-1.49-34.75-18.79-33.26-38.64.59-7.82,3.7-15.23,8.88-21.12.19-.22.47-.35.76-.36h.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3448-3323",
    "data-name": "Path 3448-3323",
    className: "cls-1",
    d: "M621.66,108.57c.27,0,.53.11.72.29.21.2.33.48.32.77l-.34,30.16c0,.58-.48,1.04-1.06,1.04-.28,0-.54-.12-.74-.32l-20.99-21.46c-.41-.42-.4-1.08.02-1.49.01-.01.03-.02.04-.04,6.1-5.37,13.84-8.53,21.96-8.96h.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3449-3324",
    "data-name": "Path 3449-3324",
    className: "cls-1",
    d: "M610.85,194.84c-.04,3.55-2.95,6.4-6.51,6.36-3.55-.04-6.4-2.95-6.36-6.51.04-3.55,2.95-6.4,6.51-6.36h0c3.55.04,6.4,2.95,6.36,6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3450-3325",
    "data-name": "Path 3450-3325",
    className: "cls-5",
    d: "M629.23,195.05c-.04,3.55-2.95,6.4-6.51,6.36-3.55-.04-6.4-2.95-6.36-6.51.04-3.55,2.95-6.4,6.51-6.36h0c3.55.04,6.4,2.95,6.36,6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3451-3326",
    "data-name": "Path 3451-3326",
    className: "cls-7",
    d: "M647.61,195.25c-.04,3.55-2.95,6.4-6.51,6.36-3.55-.04-6.4-2.95-6.36-6.51.04-3.55,2.95-6.4,6.51-6.36h0c3.55.04,6.4,2.95,6.36,6.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_776",
    "data-name": "Rectangle 776",
    className: "cls-4",
    x: 546.78,
    y: 230.46,
    width: 149.17,
    height: 113.96,
    rx: 8,
    ry: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    "data-name": "Rectangle 777",
    className: "cls-2",
    x: 554.19,
    y: 236.12,
    width: 134.35,
    height: 102.64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_778",
    "data-name": "Rectangle 778",
    className: "cls-4",
    x: 102.88,
    y: 98.56,
    width: 405.08,
    height: 245.87,
    rx: 8,
    ry: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_779",
    "data-name": "Rectangle 779",
    className: "cls-2",
    x: 110.93,
    y: 105.9,
    width: 388.98,
    height: 230.63
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3458-3333",
    "data-name": "Path 3458-3333",
    className: "cls-5",
    d: "M451.67,292.35H168.11c-.49,0-.89-.4-.89-.89v-135.91c0-.49.4-.89.89-.89s.89.4.89.89v135.02h282.67c.49,0,.89.4.89.89s-.4.89-.89.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3459-3334",
    "data-name": "Path 3459-3334",
    className: "cls-1",
    d: "M228.7,282.59h-25.79c-1.45,0-2.63-1.18-2.63-2.63v-35.55c0-1.45,1.18-2.63,2.63-2.63h25.79c1.45,0,2.63,1.18,2.63,2.63v35.55c0,1.45-1.18,2.63-2.63,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3460-3335",
    "data-name": "Path 3460-3335",
    className: "cls-1",
    d: "M275.73,282.59h-25.8c-1.45,0-2.63-1.18-2.63-2.63v-69.28c0-1.45,1.18-2.63,2.63-2.63h25.8c1.45,0,2.63,1.18,2.63,2.63v69.27c0,1.45-1.18,2.63-2.63,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3461-3336",
    "data-name": "Path 3461-3336",
    className: "cls-1",
    d: "M322.76,282.59h-25.79c-1.45,0-2.63-1.18-2.63-2.63v-35.55c0-1.45,1.18-2.63,2.63-2.63h25.79c1.45,0,2.63,1.18,2.63,2.63v35.55c0,1.45-1.18,2.63-2.63,2.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3462-3337",
    "data-name": "Path 3462-3337",
    className: "cls-1",
    d: "M369.8,282.59h-25.79c-1.42.03-2.6-1.09-2.63-2.52v-82.82c.04-1.42,1.21-2.55,2.63-2.52h25.79c1.42-.03,2.6,1.09,2.63,2.52v82.82c-.04,1.42-1.21,2.55-2.63,2.52h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3463-3338",
    "data-name": "Path 3463-3338",
    className: "cls-1",
    d: "M416.83,282.59h-25.79c-1.45,0-2.63-1.18-2.63-2.63v-106.55c0-1.45,1.18-2.63,2.63-2.63h25.79c1.45,0,2.63,1.18,2.63,2.63v106.55c0,1.45-1.18,2.63-2.63,2.63Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_539",
    "data-name": "Ellipse 539",
    className: "cls-5",
    cx: 215.8,
    cy: 225.8,
    r: 5.32
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_540",
    "data-name": "Ellipse 540",
    className: "cls-5",
    cx: 262.83,
    cy: 191.19,
    r: 5.32
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_541",
    "data-name": "Ellipse 541",
    className: "cls-5",
    cx: 309.87,
    cy: 225.8,
    r: 5.32
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_542",
    "data-name": "Ellipse 542",
    className: "cls-5",
    cx: 356.9,
    cy: 174.33,
    r: 5.32
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_543",
    "data-name": "Ellipse 543",
    className: "cls-5",
    cx: 403.93,
    cy: 154.8,
    r: 5.32
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3464-3339",
    "data-name": "Path 3464-3339",
    className: "cls-5",
    d: "M309.98,226.99l-47.14-35.31-46.5,34.83-1.06-1.42,47.57-35.63,46.92,35.14,46.63-51.02.19-.08,47.03-18.95.66,1.65-46.85,18.88-47.44,51.92Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M594.28,310.84h2l1.43,5.28,1.56-5.17h1.72l1.55,5.17,1.44-5.28h2l-2.14,7.25h-2.41l-1.3-4.4-1.3,4.4h-2.41l-2.14-7.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M605.63,314.46c0-2.21,1.58-3.77,3.73-3.77,1.99,0,3.51,1.34,3.51,3.53,0,.26-.02.54-.07.82h-5.24c.14.85,1.01,1.45,1.93,1.45.72,0,1.34-.33,1.81-1.02l1.37,1.03c-.68,1.13-1.95,1.74-3.23,1.74-2.33,0-3.82-1.68-3.82-3.79ZM611.07,313.75c-.1-.81-.76-1.43-1.68-1.43s-1.68.6-1.79,1.43h3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M613.55,318.09v-10.64h1.9v4.26c.48-.6,1.22-1.03,2.39-1.03,2.05,0,3.51,1.56,3.51,3.77s-1.46,3.78-3.51,3.78c-1.07,0-1.89-.37-2.36-.92l-.04.77h-1.9ZM617.45,316.5c1.15,0,1.96-.91,1.96-2.05s-.81-2.02-1.96-2.02-1.97.87-1.97,2.02.82,2.05,1.97,2.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M621.85,314.45c0-2.12,1.71-3.78,3.87-3.78,1.36,0,2.7.71,3.37,2.07l-1.47.94c-.42-.84-1.16-1.22-1.87-1.22-1.16,0-1.97.89-1.97,2.04s.83,2,1.94,2c.79,0,1.44-.37,1.93-1.25l1.4.98c-.66,1.32-2.02,2.02-3.38,2.02-2.18,0-3.82-1.68-3.82-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M629.55,318.09v-10.64h1.94v4.15c.38-.46,1.13-.92,2.18-.92,1.66,0,2.85,1.1,2.85,2.85v4.55h-1.94v-4.06c0-1-.64-1.55-1.48-1.55s-1.6.54-1.6,1.55v4.06h-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M637.05,314.46c0-2.21,1.58-3.77,3.73-3.77,1.99,0,3.51,1.34,3.51,3.53,0,.26-.02.54-.07.82h-5.24c.14.85,1.01,1.45,1.93,1.45.72,0,1.34-.33,1.81-1.02l1.37,1.03c-.68,1.13-1.95,1.74-3.23,1.74-2.33,0-3.82-1.68-3.82-3.79ZM642.49,313.75c-.1-.81-.76-1.43-1.68-1.43s-1.68.6-1.79,1.43h3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M644.48,314.45c0-2.12,1.71-3.78,3.87-3.78,1.36,0,2.7.71,3.37,2.07l-1.47.94c-.42-.84-1.16-1.22-1.87-1.22-1.16,0-1.97.89-1.97,2.04s.83,2,1.94,2c.79,0,1.44-.37,1.93-1.25l1.4.98c-.66,1.32-2.02,2.02-3.38,2.02-2.18,0-3.82-1.68-3.82-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M661.33,307.4c.66,0,1.12.45,1.12,1.12s-.46,1.11-1.12,1.11-1.11-.45-1.11-1.11.45-1.12,1.11-1.12ZM660.37,318.09v-7.25h1.94v7.25h-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M663.42,318.09v-7.25h1.84l.04.84c.38-.51,1.16-.99,2.24-.99,1.68,0,2.86,1.1,2.86,2.85v4.55h-1.93v-4.06c0-1-.65-1.55-1.5-1.55s-1.61.54-1.61,1.55v4.06h-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M655.25,315.41c-.43.08-.87.12-1.35.15v2.52h-1.96v-11.14h1.96v4.66c.96-.97,2.2-1.59,3.42-1.59,1.45,0,2.41.85,2.41,2.12s-.93,2.2-2.58,2.8l-1.9.48ZM653.9,314.13c2.54-.25,4.07-.93,4.07-1.81,0-.43-.37-.71-.97-.71-1.01,0-2.29.73-3.09,1.79v.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M656.37,313.93l3.24,4.15h-2.39l-2.14-2.9"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M579.87,317.12c-.74,0-1.45-.29-1.97-.82l-1.56-1.56,1.73-1.73,1.57,1.57c.08.08.18.1.24.1s.16-.02.24-.1l3.59-3.59,1.73,1.73-3.59,3.59c-.53.53-1.23.82-1.97.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M586.38,321.18h-11.25c-2.05,0-3.72-1.67-3.72-3.72v-4.59c0-.99.39-1.93,1.09-2.63l5.62-5.62c.7-.7,1.63-1.09,2.63-1.09s1.93.39,2.63,1.09l5.62,5.62c.7.7,1.09,1.63,1.09,2.63v4.59c0,2.05-1.67,3.72-3.72,3.72ZM580.75,305.98c-.34,0-.66.13-.9.37l-5.62,5.62c-.24.24-.37.56-.37.9v4.59c0,.7.57,1.27,1.27,1.27h11.25c.7,0,1.27-.57,1.27-1.27v-4.59c0-.34-.13-.66-.37-.9l-5.62-5.62c-.24-.24-.56-.37-.9-.37Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_536",
    "data-name": "Ellipse 536",
    className: "cls-5",
    cx: 576.99,
    cy: 261.83,
    r: 5.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3452-3327",
    "data-name": "Path 3452-3327",
    className: "cls-5",
    d: "M666.62,257.49c2.09,0,3.78,1.69,3.78,3.78s-1.69,3.78-3.78,3.78h-58.67c-2.09,0-3.78-1.69-3.78-3.78s1.69-3.78,3.78-3.78h58.67M666.62,256.56h-58.67c-2.6-.04-4.74,2.04-4.78,4.64-.04,2.6,2.04,4.74,4.64,4.78.05,0,.09,0,.14,0h58.67c2.6.04,4.74-2.04,4.78-4.64.04-2.6-2.04-4.74-4.64-4.78-.05,0-.09,0-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3453-3328",
    "data-name": "Path 3453-3328",
    className: "cls-1",
    d: "M643.47,265.98h-44.16c-2.6-.04-4.68-2.18-4.64-4.78.04-2.55,2.09-4.6,4.64-4.64h44.16c2.6.04,4.68,2.18,4.64,4.78-.04,2.55-2.09,4.6-4.64,4.64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_537",
    "data-name": "Ellipse 537",
    className: "cls-5",
    cx: 576.99,
    cy: 284.99,
    r: 5.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3454-3329",
    "data-name": "Path 3454-3329",
    className: "cls-5",
    d: "M666.62,280.65c2.09,0,3.78,1.69,3.78,3.78s-1.69,3.78-3.78,3.78h-58.67c-2.09,0-3.78-1.69-3.78-3.78s1.69-3.78,3.78-3.78h58.67M666.62,279.72h-58.67c-2.6.04-4.68,2.18-4.64,4.78.04,2.55,2.09,4.6,4.64,4.64h58.67c2.6.04,4.74-2.04,4.78-4.64.04-2.6-2.04-4.74-4.64-4.78-.05,0-.09,0-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3455-3330",
    "data-name": "Path 3455-3330",
    className: "cls-1",
    d: "M660.14,289.14h-60.84c-2.6-.04-4.68-2.18-4.64-4.78.04-2.55,2.09-4.6,4.64-4.64h60.84c2.6.04,4.68,2.18,4.64,4.78-.04,2.55-2.09,4.6-4.64,4.64h0Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard002);
export default __webpack_public_path__ + "static/media/Dashboard 002.d30fcf1a6ddc3493d37ecb131940aa5b.svg";
export { ForwardRef as ReactComponent };